import React, { useEffect, useState } from "react";
import { Select } from "antd";
import locationService from "../../services/location"; // adjust path if needed

const { Option } = Select;

const LocationComponent = ({
  value,
  onChange,
  exclude = [], // array of location IDs to exclude
  all = false,
}) => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);

  // ================= FETCH LOCATIONS =================
  const getLocations = async () => {
    setLoading(true);
    try {
      const response = await locationService.getLocations();
      setLocations(response.data || []);
    } catch (error) {
      console.error("Failed to fetch locations");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getLocations();
  }, []);

  // ================= FILTER =================
  const filteredLocations = locations.filter(
    (loc) => !exclude.includes(loc.id) || loc.id === value // allow current selected
  );

  return (
    <Select
      showSearch
      value={value}
      loading={loading}
      onChange={onChange}
      placeholder="Select Location"
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
      allowClear
    >
      {filteredLocations.map((loc) => (
        <Option key={loc.id} value={loc.id}>
          {loc.name}
        </Option>
      ))}
    </Select>
  );
};

export default LocationComponent;